import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Params, ActivatedRoute } from '@angular/router';
import { StorageService } from './../../../services/storage/storage.service';
import { AuthService, LoginRequest } from './../../../services/auth/auth.service';
import { SharedService } from './../../../services/shared/shared.service';

@Component({
  selector: 'ag-giplogin',
  templateUrl: './giplogin.component.html',
  styleUrls: ['./giplogin.component.scss'],
})
export class GiploginComponent implements OnInit {
  gip: any;
  dataid: any;
  isGipLogin = true;
  canRender = false;

  private _cid: any;
  private _lid: any;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _authService: AuthService,
    private _sharedService: SharedService,
    private _storageService: StorageService,
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) {}

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe(async (params: Params) => {
      this.gip = params['gip'];
      this.dataid = params['dataid'];
      this._cid = params['cid'];
      this._lid = params['lid'];

      const obj = {
        cid: this._cid,
        lid: this._lid,
        dataid: this.dataid,
        gip: this.gip,
      };

      const validateRequest = this._validateIncomingRequest(obj);
      if (validateRequest) {
        await this._guestLoginPromise();
      } else {
        const message = 'please pass all the required parameters to the url and try again';
        this._sharedService.openSnackBar(message, 'ok');
      }
    });
  }

  private _guestLoginPromise(): void {
    this._authService.login(this._createGuestLoginRequest()).subscribe(
      () => {
        this.canRender = true;
      },
      (error: unknown) => {
        if (error instanceof Error) {
          this._sharedService.openSnackBar(error.message, 'ok');
        }
      },
    );
  }

  private _validateIncomingRequest(obj): boolean {
    let success = false;
    if (
      obj.hasOwnProperty('cid') &&
      obj.hasOwnProperty('lid') &&
      obj.hasOwnProperty('dataid') &&
      obj.hasOwnProperty('gip')
    ) {
      success = true;
    }
    return success;
  }

  private _createGuestLoginRequest(): LoginRequest {
    const result = {
      grant_Type: 'password',
      cid: this._cid ? this._cid : this._storageService.getCid(),
      lid: this._lid ? this._lid : this._storageService.getLid(),
      userName: 'guest',
      password: 'guest',
      rememberMe: false,
    };
    return result;
  }
}
